import doormanReducer from '@/state/modules/doorman/reducers';

export { default as actions } from '@/state/modules/doorman/actions';
export { default as sagas } from '@/state/modules/doorman/sagas';
export { default as operations } from '@/state/modules/doorman/operations';
export { default as selectors } from '@/state/modules/doorman/selectors';

export default doormanReducer;
